import { usePostHog } from '@posthog/react'
import { useEffect } from 'react'

import { useUserQuery } from 'STORE/endpoints/root'

const PostHogIdentify = (): null => {
  const posthog = usePostHog()
  const { data: user } = useUserQuery()

  useEffect(() => {
    if (user?.id) {
      posthog?.identify(user.id, {
        name: user.name,
        email: user.email,
      })
    }
  }, [posthog, user?.id, user?.name, user?.email])

  return null
}

export default PostHogIdentify
